import { ImageAnnotationMetadata } from '@euler/app/flows/media/annotation/functions/AnnotationMetadata';
import { MediaObject } from '@euler/model/MediaObject';
import { MediaSource } from '@euler/model/MediaSource';
import { MediaSourceType } from '@euler/model/report';

export type TaskMedia = {
  id: number;
  cid: string;
  type: string;
  url: string;
  coverUrl?: string;
  title?: string;
  subTitle?: string;
  dateRef?: string | Date;
  createdAt: string | Date;
  remark?: string;
  annotationMetadata?: string;
};

export type TaskMediaCommitPayload = Omit<
  TaskMedia,
  'id' | 'dateRef' | 'createdAt' | 'cid'
> & { id?: number };

export type AnyStagedMedia = {
  _key: string;
  _source: MediaSource;
  _timestamp: number;
  annotationMetadata?: ImageAnnotationMetadata;
};

export type TaskMediaStaged = Omit<
  TaskMediaCommitPayload,
  'url' | 'annotationMetadata'
> &
  AnyStagedMedia;

export type TaskMediaWithSource = {
  cid: string;
  orgId: number;
  storeId: number;
  taskId: number;
  vin: string;
  source: MediaSourceType;
  sourceMediaId: number;
  type: string;
  key: string;
  url: string;
  coverUrl?: string | null;
  urlWithAnnotation?: string;
  title?: string | null;
  subTitle?: string | null;
  description?: string | null;
  dateRef: string | Date;
  createdAt: string | Date;
};

export const taskMediaWithSourceToTaskMedia = (
  media: TaskMediaWithSource,
): TaskMedia => {
  return {
    id: media.sourceMediaId,
    cid: media.cid,
    type: media.type,
    url: media.url,
    coverUrl: media.coverUrl ?? undefined,
    title: media.title ?? undefined,
    subTitle: media.subTitle ?? undefined,
    dateRef: media.dateRef,
    createdAt: media.createdAt,
    remark: media.description ?? undefined,
  };
};

export const taskMediaWithSourceToMediaObject = (
  media: TaskMediaWithSource,
  options?: {
    preferOriginalUrl?: boolean;
  },
): MediaObject => {
  return {
    id: media.cid,
    type: /image/i.test(media.type) ? 'image' : 'video',
    url: media.url,
    coverUrl:
      /image/i.test(media.type) && options?.preferOriginalUrl
        ? undefined
        : media.coverUrl ?? undefined,
    title: media.title ?? undefined,
    subTitle: media.subTitle ?? undefined,
    description: media.description ?? undefined,
  };
};

export const taskMediaToMediaObject = (
  media: TaskMedia,
  options?: {
    preferOriginalUrl?: boolean;
  },
): MediaObject => {
  return {
    id: media.cid,
    type: /image/i.test(media.type) ? 'image' : 'video',
    url: media.url,
    coverUrl:
      /image/i.test(media.type) && options?.preferOriginalUrl
        ? undefined
        : media.coverUrl,
    title: media.title ?? undefined,
    subTitle: media.subTitle ?? undefined,
    description: media.remark ?? undefined,
  };
};
